export const NFT_COLLECTION_ADDRESS = process.env.REACT_APP_NFT_COLLECTION_ADDRESS || "";
export const TON_CENTER_HOST = process.env.REACT_APP_TON_CENTER_HOST || "";
export const TON_CENTER_API_KEY = process.env.REACT_APP_TON_CENTER_API_KEY || "";
export const MINTER_ADDRESS = process.env.REACT_APP_MINTER_ADDRESS || "";
export const CONTRACT_CREATOR = process.env.REACT_APP_CONTRACT_CREATOR || "";

export const BLOCKCHAIN_QUERY_PARAM = "blockchain";

export const request = {
  pathToBig: "/cutting",
  pathToMin: "/cutting",
};
